import { render } from "./BModal.vue?vue&type=template&id=0f5c96c2&scoped=true&ts=true"
import script from "./BModal.vue?vue&type=script&lang=ts"
export * from "./BModal.vue?vue&type=script&lang=ts"

import "./BModal.vue?vue&type=style&index=0&id=0f5c96c2&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f5c96c2"]])

export default __exports__